var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M12 38h2v-7h-2zM68 60H26v-2h40V31h2v29",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 28V16h56v2H11v10c0 1.103.897 2 2 2s2-.897 2-2v-5h2v5c0 2.206-1.794 4-4 4s-4-1.794-4-4z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 32c-2.206 0-4-1.794-4-4h2c0 1.103.897 2 2 2s2-.897 2-2v-5h2v5c0 2.206-1.794 4-4 4",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 32c-2.206 0-4-1.794-4-4h2c0 1.103.897 2 2 2s2-.897 2-2v-5h2v5c0 2.206-1.794 4-4 4",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 32c-2.206 0-4-1.794-4-4h2c0 1.103.897 2 2 2s2-.897 2-2v-5h2v5c0 2.206-1.794 4-4 4",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 32c-2.206 0-4-1.794-4-4h2c0 1.103.897 2 2 2s2-.897 2-2v-5h2v5c0 2.206-1.794 4-4 4",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 32c-2.206 0-4-1.794-4-4h2c0 1.103.897 2 2 2s2-.897 2-2v-5h2v5c0 2.206-1.794 4-4 4",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 32c-2.206 0-4-1.794-4-4h2c0 1.103.897 2 2 2s2-.897 2-2v-5h2v5c0 2.206-1.794 4-4 4",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 32c-2.206 0-4-1.794-4-4h2c0 1.103.897 2 2 2s2-.897 2-2v-5h2v5c0 2.206-1.794 4-4 4",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 32c-2.206 0-4-1.794-4-4h2c0 1.103.897 2 2 2s2-.897 2-2v-5h2v5c0 2.206-1.794 4-4 4",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 32c-2.206 0-4-1.794-4-4h2c0 1.103.897 2 2 2s2-.897 2-2v-5h2v5c0 2.206-1.794 4-4 4",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 32c-2.206 0-4-1.794-4-4h2c0 1.103.897 2 2 2s2-.897 2-2v-5h2v5c0 2.206-1.794 4-4 4",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49 32c-2.206 0-4-1.794-4-4h2c0 1.103.897 2 2 2s2-.897 2-2v-5h2v5c0 2.206-1.794 4-4 4",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 32c-2.206 0-4-1.794-4-4h2c0 1.103.897 2 2 2s2-.897 2-2v-5h2v5c0 2.206-1.794 4-4 4",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 32c-2.206 0-4-1.794-4-4h2c0 1.103.897 2 2 2s2-.897 2-2v-5h2v5c0 2.206-1.794 4-4 4",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 32c-2.206 0-4-1.794-4-4h2c0 1.103.897 2 2 2s2-.897 2-2v-5h2v5c0 2.206-1.794 4-4 4",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 32c-2.206 0-4-1.794-4-4h2c0 1.103.897 2 2 2s2-.897 2-2v-5h2v5c0 2.206-1.794 4-4 4",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M62 59h-2V40H50v19h-2V38h14v21M30 53h2V39h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M49 50h3v-2h-3zM42 54H28v-2h12V40H22v-2h20v16",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 32c-2.206 0-4-1.794-4-4h2c0 1.103.897 2 2 2s2-.897 2-2V18h-4v-2h6v12c0 2.206-1.794 4-4 4",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M16 63h2V51h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 40.586C14.511 43.72 10 50.019 10 53c0 3.318 2.355 5 7 5s7-1.682 7-5c0-2.984-4.511-9.281-7-12.414zM17 60c-5.72 0-9-2.551-9-7 0-4.646 7.39-13.632 8.232-14.641.38-.455 1.156-.455 1.536 0C18.61 39.368 26 48.354 26 53c0 4.449-3.28 7-9 7zM8 64h64v-2H8z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationShop;